import { CUSTOM_TYPE_MODEL_FILENAME } from "./constants.js";
import { writeCustomTypeFile } from "./writeCustomTypeFile.js";
const writeCustomTypeModel = async (args) => {
  return await writeCustomTypeFile({
    ...args,
    customTypeID: args.model.id,
    filename: CUSTOM_TYPE_MODEL_FILENAME,
    contents: JSON.stringify(args.model, null, 2)
  });
};
export {
  writeCustomTypeModel
};
//# sourceMappingURL=writeCustomTypeModel.js.map
